interface IHandleDocumentCreateErrorProps {
  res: any;
  enqueueSnackbar: any;
  translate: (text: string, options?: any) => string;
  handleResolveDuplicateDoc: (docNumber: string) => void;
}

export const handleDocumentCreateError = ({
  res,
  enqueueSnackbar,
  translate,
  handleResolveDuplicateDoc,
}: IHandleDocumentCreateErrorProps) => {
  const isDuplDocNum = res?.data?.DynamicMessages?.some(
    (msg: any) => msg.MessageKey === "document_number_already_assigned",
  );
  if (isDuplDocNum) {
    const errorMessage = res?.data?.Detail || "";
    const docNum: string =
      errorMessage.match(/Document Number '([^']+)'/)?.[1] || "";
    handleResolveDuplicateDoc(docNum);
  } else if (res?.data?.errors) {
    const errorMessage = Object.values(
      res.data.errors as Record<string, string[]>,
    ).reduce(
      (acc: string, messages: string[]) =>
        `${acc}${acc ? " " : ""}${messages.join(" ")}`,
      "",
    );
    enqueueSnackbar(errorMessage || translate("something_went_wrong"), {
      variant: "error",
    });
  } else {
    enqueueSnackbar(res?.data?.Detail ?? translate("something_went_wrong"), {
      variant: "error",
    });
  }
};
